import React, { Component, Fragment } from 'react';
import { Redirect, Link, withRouter } from 'react-router-dom';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Container from 'react-bootstrap/Container';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { FieldGroup, Alert} from '../../helpers/BootstrapHelpers';
import AdminTBD from './AdminTBD';
import ItemScoringDefs from './ItemScoringDefs';
import ItemResDefs from './ItemResDefs';
import ItemDefs from './ItemDefs';
import MetricsAccount from './metricsAccount';
import MetricsUsage from './metricsUsage';
import MetricsAssessment from './metricsAssessment';
import authService from '../../services/AuthService';
import api, { apiErrorHandler, apiResponseHandler } from '../../services/AxiosService';
import { alertPopup, confirmPopup, apiErrorPopup } from '../../helpers/MessagePopup';

import cadeHeader from '../../content/CADEAIHeader.png';

import '../../index.css';
import './Admin.css';

class AdminHome extends Component {

    constructor (props) {
        super(props);

        this.state = {
            domain: null,
            activeTab: "accountMetrics",
            successAlert: null,
            errorAlert: null
        }

        this.itemScoreDefs = null;
        this.itemResDefs = null;
        this.itemDefs = null;
    }

    itemResourceChangeHandler = (itemResDefs) => {
        this.itemResDefs = itemResDefs;
    }

    itemScoringChangeHandler = (itemScoreDefs) => {
        this.itemScoreDefs = itemScoreDefs;
    }

    itemChangeHandler = (itemDefs) => {
        this.itemDefs = itemDefs;
    }

    domainChangeHandler = (e) => {
        this.setState({ domain: e.target.value });
    }

    changeTab = (key) => {
        if (this.anyChanges()) {
            confirmPopup('warning', "There are changes pending.  Do you want to save?", null, "Yes", "No", this.saveChangeHandler, null);
        }
        this.setState({ activeTab: key })
    }

    anyChanges = () => {
        return (this.itemScoreDefs != null || this.itemResDefs != null || this.itemDefs != null);
    }
    saveChangesHandler = () => {
        // This method checks each tab for changes and, if some, calls the appropriate handler to save them to the database
        if (this.itemScoreDefs != null) {
            this.saveChanges("/admin/itemScoring", "Item Scoring", this.itemScoreDefs);
            this.itemScoreDefs = null;
        }

        if (this.itemResDefs != null) {
            this.saveChanges("/admin/itemResources", "Item Resources", this.itemResDefs);
            this.itemResDefs = null;
        }

        if (this.itemDefs != null) {
            this.saveChanges("/admin/items", "Item Definitions", this.itemDefs);
            this.itemDefs = null;
        }
    }

    saveChanges = (url, which, defs) => {
        api.post(url, defs,
            {
                headers: {
                    Authorization: 'Bearer ' + authService.token
                }
            })
            .then((response) => {
                if (response.status != 200) {
                    this.setState({ errorAlert: apiResponseHandler(response) });
                    apiErrorPopup(apiResponseHandler(response));
                }
                else {
                    this.setState({ successAlert: which + " saved successfully.  If you added or removed rows, click off and back on this tab to refresh." });
                }
            })
            .catch((error) => {
                // Major problem!
                apiErrorPopup(apiErrorHandler(error));
                return;
            });
    }

    hideSuccessAlert = () => {
        this.setState({ successAlert: null });
    }

    hideErrorAlert = () => {
        this.setState({ errorAlert: null });
    }

    render() {
        if (!authService.isAuthenticated || authService.authenticatedUserName != "clear") {
            return (<Redirect to='/' />);
        }

        return (
            <Fragment>
                <Container fluid>
                    <Link to="/home"><img src={cadeHeader} className="cadeHeader" alt="CADE Header" /></Link>
                    <Link to={{
                        pathname: '/'
                    }}>
                        <Button variant="outline-secondary" className="admin_logoutButton">Logout</Button>
                    </Link>
                    <h2>CADE Administration</h2>
                    <Accordion defaultActiveKey="0">
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey="0">
                                Metrics
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="0">
                                <Card.Body>
                                    <Tabs id="adminTabs" activeKey={this.state.activeTab} onSelect={(key) => this.changeTab(key)}>
                                        <Tab
                                            eventKey="accountMetrics"
                                            title="Account Metrics"
                                            unmountOnExit
                                        >
                                            <MetricsAccount
                                            />
                                        </Tab>
                                        <Tab
                                            eventKey="usageMetrics"
                                            title="Usage Metrics"
                                            unmountOnExit
                                        >
                                            <MetricsUsage
                                            />
                                        </Tab>
                                        <Tab
                                            eventKey="assessmentMetrics"
                                            title="Assessment Metrics"
                                            unmountOnExit
                                        >
                                            <MetricsAssessment
                                            />

                                        </Tab>
                                    </Tabs>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey="1">
                                CADE Data Administration
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="1">
                                <Card.Body>
                                   
                                    <Form>
                                        <Container>
                                            <Row>
                                                <Col sm={9}>
                                                    <FieldGroup
                                                        id="domainName"
                                                        type="text"
                                                        label="Domain"
                                                        placeholder="Domain name (leave empty if all domains wanted)"
                                                        defaultValue={this.state.domain}
                                                        onBlur={this.domainChangeHandler}
                                                    />
                                                </Col>
                                                <Col sm={3}>
                                                    <Button variant="outline-primary" onClick={this.saveChangesHandler} className="admin_saveChangesButton" >Save Changes</Button>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col sm={12}>
                                                    <Alert show={this.state.successAlert} hideAlertHandler={this.hideSuccessAlert} variant="info" />

                                                    <Alert show={this.state.errorAlert} hideAlertHandler={this.hideErrorAlert} variant="warning" />
                                                </Col>
                                            </Row>
                                        </Container>
                                    </Form>
                                    <Tabs id="adminTabs" activeKey={this.state.activeTab} onSelect={key => this.changeTab(key)}>
                                        <Tab
                                            eventKey="assessmentDefs"
                                            title="Assessment Definitions"
                                            unmountOnExit
                                        >
                                            <AdminTBD
                                            />
                                        </Tab>
                                        <Tab
                                            eventKey="domainDefs"
                                            title="Domain Definitions"
                                            unmountOnExit
                                        >
                                            <AdminTBD
                                            />
                                        </Tab>
                                        <Tab
                                            eventKey="itemDefs"
                                            title="Item Definitions"
                                            unmountOnExit
                                        >
                                            <ItemDefs
                                                domain={this.state.domain}
                                                itemChangeHandler={this.itemChangeHandler}
                                                key={"itemDefs"}
                                            />
                                        </Tab>
                                        <Tab
                                            eventKey="itemScoring"
                                            title="Item Scoring"
                                            unmountOnExit   // This unmounts the tab and remounts it (causing the api to re-fill with data)
                                        >
                                            <ItemScoringDefs
                                                domain={this.state.domain}
                                                itemScoringChangeHandler={this.itemScoringChangeHandler}
                                                key={"itemScoringDefs"}
                                            />
                                        </Tab>
                                        <Tab
                                            eventKey="itemResources"
                                            title="Item Resources"
                                            unmountOnExit
                                        >
                                            <ItemResDefs
                                                domain={this.state.domain}
                                                itemResourceChangeHandler={this.itemResourceChangeHandler}
                                                key={"itemResDefs"}
                                            />
                                        </Tab>
                                        <Tab
                                            eventKey="authnet"
                                            title="Authorize.Net"
                                            unmountOnExit
                                        >

                                        </Tab>
                                    </Tabs>
                                   
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                </Container>
            </Fragment>
        )
    }
}


export default withRouter(AdminHome);


// WEBPACK FOOTER //
// ./src/components/AdminHome/AdminHome.js